<template>
  <div class="full">
    <Header />
    <Loading :active="loading" />
    <div v-if="exam && !error_type" class="container cantCopy">
      <!-- EXAM -->
      <div class="exam">
        <v-select
          v-model="currentQuestionNumber"
          :items="questions"
          item-text="label"
          item-value="id"
          persistent-hint
          single-line
          solo
          :disabled="isOffline"
        ></v-select>
        <router-view :isOffline="isOffline" @questionLoaded="questionLoadedHandler"></router-view>
        <div class="exam__actions">
          <v-btn
            color="accent"
            v-show="currentQuestionNumber > 1"
            @click="
              go(-1);
              show_end = false;
            "
            :disabled="isOffline"
            :loading="loadingChangeQuestion  && increment == -1"
          >
            Anterior
          </v-btn>
          <div></div>
          <v-btn
            color="accent"
            v-show="currentQuestionNumber < this.exam.numberOfQuestions"
            @click="go(1)"
            :disabled="isOffline"
            :loading="loadingChangeQuestion && increment == 1"
          >
            Siguiente
          </v-btn>
          <v-btn
            color="accent"
            v-show="currentQuestionNumber === this.exam.numberOfQuestions"
            @click="end()"
            :disabled="isOffline"
          >
            Finalizar
          </v-btn>
        </div>
        <ScrollButton class="scroll-btn" />
      </div>
    </div>

    <section class="mx-auto text-center my-4 card" v-show="error_type">
      <p>{{ error_type }}</p>
      <button class="button button--primary" @click="redirect()">Salir</button>
    </section>

    <m-dialog v-model="showConfirmExamEndDialog">
      <div style="margin: 10px 10px 20px 10px">
        <p>
          Ha llegado al final del examen. Puede volver y modificar sus
          respuestas, o finalizar su participación.
        </p>
        <p>
          Si finaliza su participación
          <strong>ya no podrá modificar sus respuestas</strong>.
        </p>
      </div>
      <div class="card__actions">
        <button class="button" @click="showConfirmExamEndDialog = false">
          Cancelar
        </button>
        <v-btn
          class="button button--primary"
          @click="finalizarExamen"
          color="accent"
          :loading="finishExamLoading"
        >
          Finalizar
        </v-btn>
      </div>
    </m-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import Header from "@/components/Header";
import { postulantExam } from "@/services/postulantExam";
import { removeSession } from "@/services/session";
import range from "lodash/range";
import { genericErrorHandler } from "@/services/error";
import ScrollButton from "@/components/ScrollButton";
import { event } from "@/services/event";

/**
 * A setTimeout that don't do setTimeout when timeout is broken
 */
const timerAt = (f, milliseconds) => ({
  timerId: null,
  run() {
    const isSetTimeoutBroken = milliseconds < 2147483647; // like 24days

    // see https://developer.mozilla.org/es/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
    if (isSetTimeoutBroken) this.timerId = setTimeout(f, milliseconds);
  },
  stop() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
});

export default {
  data: () => ({
    finishExamLoading: false,
    showConfirmExamEndDialog: false,
    event: null,
    exam: null,
    error_type: "",
    loading: true,
    dialog_end: false,
    currentQuestionNumber: null,
    isOffline: false,
    increment : null,

    timer: null,
    loadingChangeQuestion: false
  }),
  async mounted() {
    const handle422 = (response) => {
      switch (response.detail) {
        case "exam_event.not_started":
          return "Examen aun no inicia, empezará a las: " + response.args.start;
      }
    };

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    // TODO: refactor
    const eventExamId = 1;

    this.event = (await event.get(eventExamId)).data;

    let millisTillOccurence = Math.max(
      new Date(this.event.range.end).getTime() - new Date().getTime(),
      0
    );

    this.timer = timerAt(() => {
      this.$router.push({
        query: { type: "date" },
        name: "examEnded",
      });
    }, millisTillOccurence);
    this.timer.run();

    postulantExam
      .startOrGet({ eventExamId: eventExamId })
      .then(({ data }) => {
        this.exam = data;

        if (!this.currentQuestionNumber) {
          this.currentQuestionNumber = 1;
        }
      })
      .catch((e) => {
        this.error_type = genericErrorHandler(e, handle422);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);

    this.timer.stop();
  },
  watch: {
    "$route.params": {
      handler: async function({ question }) {
        this.currentQuestionNumber = parseInt(question);
      },
      immediate: true,
    },
    async currentQuestionNumber() {
      if (this.exam.actualRange.end) {
        this.$router.push({
          query: { type: "alreadyEndedByUser" },
          name: "examEnded",
        });
        return;
      }

      if (this.currentQuestionNumber) {
        this.$router.push({
          name: "questionPostulant",
          params: { question: this.currentQuestionNumber },
        });
      }
    },
  },

  methods: {
    questionLoadedHandler(){
      this.loadingChangeQuestion = false
    },
    finalizarExamen() {
      this.finishExamLoading = true;

      postulantExam
        .finish({ id: this.exam.id })
        .then(() => {
          this.$router.push({
            name: "examEnded",
            query: { type: "endedByUser" },
          });
        })
        .catch((e) => {
          this.$swal("Oops...", genericErrorHandler(e), "error");
        })
        .finally(() => {
          this.finishExamLoading = false;
        });
    },
    async go(step) {
      this.increment = step
      this.loadingChangeQuestion = true
      this.currentQuestionNumber += step;
    },
    updateOnlineStatus(e) {
      this.isOffline = e.type === "offline";
      if (this.isOffline) {
        this.$swal("Oops...", "Ha perdido conexion a internet", "error");
      }
    },

    async end() {
      this.showConfirmExamEndDialog = true;
    },
    //
    redirect() {
      removeSession();
      this.$router.push({
        name: "login",
      });
    },
  },
  components: {
    Loading,
    Header,
    ScrollButton,
  },
  computed: {
    questions() {
      return range(1, this.exam.numberOfQuestions + 1).map((q) => ({
        id: q,
        label: "Pregunta " + q,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.v-select__selections {
    font-size: 18px !important;
    font-weight: bold !important;
    text-transform: uppercase !important;
}
   
.cantCopy {
  user-select: none;
}

.exam {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  // &__select {
  // }
  &__actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  &__end {
    width: 100%;
    max-width: 400px;
    margin: 20px auto;
    padding: 20px;
    font-size: 1.2rem;
    text-align: center;
  }
}

@media only screen and (max-width: 1050px) {
  .scroll-btn {
    display: none;
  }
}
</style>
